import { AvailabilityTypeSimple, AvailabilityTypeSimpleQuery } from '@dreryk/egabinet-appointment-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';

export const useSearchAvailabilityTypes = (): UseCqrsQueryResult<AvailabilityTypeSimple[]> => {
   return useCqrsSearch<AvailabilityTypeSimple>(() => new AvailabilityTypeSimpleQuery(), undefined, {
      cacheTime: 'long',
   });
};
